import {FiArrowRight} from "react-icons/fi";

import CloudMonitoringSvg from "@/assets/images/cloud-monitoring.svg";
import StatusPageUpSvg from "@/assets/images/status-page-up.svg";
import {Icon} from "@/components/icon/Icon.tsx";
import {URL_ORIGINAL_WEBSITE} from "@/lib/links.ts";
import {CTABanner} from "@/marketingPages/components/ctabanner/CTABanner.tsx";

interface StatusPageBannerProps {
  serviceName: string;
}

export const StatusPageBanner = ({serviceName}: StatusPageBannerProps) => {
  return (
    <CTABanner
      left={<img src={StatusPageUpSvg} alt="Status Page" />}
      middleText={
        <div>
          See {serviceName} outages on your Status Page.
          <br />
          Place any vendor on your own page and notify your customers.
        </div>
      }
      middleButton={
        <a
          href={`${URL_ORIGINAL_WEBSITE}/accounts/register`}
          className="pulse-color-green-500 marketingTextBtn d-flex align-items-center flex-column flex-md-row"
        >
          Monitor third party services and websites on your Status Page today
          <Icon icon={FiArrowRight} />
        </a>
      }
      right={<img src={CloudMonitoringSvg} alt="Third Party Monitoring" />}
    />
  );
};
